/**
 * Created by Karol Kluska on 29.11.17.
 */

angular
  .module('app')
  .factory('Currency', Currency);

function Currency() {
  var currency = null;
  var currencyPrefix = null;
  var currencySuffix = null;

  function getCurrency() {
    return currency;
  }

  function setCurrency(currencyCode) {
    currency = currencyCode;
  }

  function getCurrencyPrefix() {
    return currencyPrefix;
  }

  function setCurrencyPrefix(prefix) {
    currencyPrefix = prefix;
  }

  function getCurrencySuffix() {
    return currencySuffix;
  }

  function setCurrencySuffix(suffix) {
    currencySuffix = suffix;
  }

  function getFormattedPrice(amount) {
    var result = amount.toString();
    if (currencyPrefix !== null) {
      result = currencyPrefix + result;
    }
    if (currencySuffix !== null) {
      result += currencySuffix;
    }
    return result;
  }

  return {
    getCurrency: getCurrency,
    setCurrency: setCurrency,
    getCurrencyPrefix: getCurrencyPrefix,
    setCurrencyPrefix: setCurrencyPrefix,
    getCurrencySuffix: getCurrencySuffix,
    setCurrencySuffix: setCurrencySuffix,
    getFormattedPrice: getFormattedPrice
  };
}
